const initialState = {
    isOpen: false,
    product: {},
    inventory: '',
    price: '',
    priceOld: '',
    productKey: 0, // indexe marbut be mahsoolat
};
const modalEditFromStock = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGE_DATA_MODAL_EDIT_FROM_STOCK':
            return {...state, [action.name]: action.value};
        default:
            return state;
    }
};

export default modalEditFromStock;
